module.exports = __webpack_public_path__ + "static/media/zhao.00c16a6c.png";